/* ============================================================
   BioActive+ Glutathione PDP — vanilla JS for Shopify Dawn
   No dependencies. Self-initialises for each .pdp section.
   Targets the same class names as glutathione-pdp.css.
   (Subscription removed — one-time purchase only.)
   ============================================================ */
(function () {
  'use strict';
  var AED = function (n) {
    var num = Number(n); if (isNaN(num)) return n;
    return num.toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initRoot(root) {
    if (!root || root.__pdpInit) return;
    root.__pdpInit = true;

    initAnnounce(root);
    initGallery(root);
    initBuyBox(root);
    initStickyBar(root);
    initReadMore(root);
    initSciTabs(root);
    initAccordions(root);
    initRings(root);
    initBundle(root);
    initReveal(root);
  }

  /* ---------------- announcement ticker ---------------- */
  function initAnnounce(root) {
    var msgs = $$('.pdp-announce-msg', root);
    if (msgs.length < 2) return;
    var parent = msgs[0].parentNode;
    if (parent.__initDone) return;
    parent.__initDone = true;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 3200);
  }

  /* ---------------- hero gallery carousel ---------------- */
  function initGallery(root) {
    var gallery = $('.pdp-gallery', root);
    if (!gallery || gallery.__initDone) return;
    gallery.__initDone = true;
    var slides = $$('.pdp-slide', gallery);
    var dots = $$('.pdp-dot', gallery);
    var n = slides.length, a = 0;
    function go(k) {
      a = (k + n) % n;
      slides.forEach(function (s, idx) { s.classList.toggle('on', idx === a); });
      dots.forEach(function (d, idx) { d.classList.toggle('on', idx === a); });
    }
    var prev = $('.pdp-arr.prev', gallery), next = $('.pdp-arr.next', gallery);
    if (prev) prev.addEventListener('click', function () { go(a - 1); });
    if (next) next.addEventListener('click', function () { go(a + 1); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });

    /* mobile swipe — horizontal drag on the image advances slides (arrows hidden on mobile) */
    var swipeArea = $('.pdp-main', gallery) || gallery;
    var sx = 0, sy = 0, swiping = false;
    swipeArea.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
    }, { passive: true });
    swipeArea.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? a + 1 : a - 1);
    }, { passive: true });
    go(0);
  }

  /* ---------------- buy box (stack + price) — one-time only ---------------- */
  function readStacks(root) {
    // each .pdp-stack carries data-id, data-price, data-was, data-name, data-variant
    var out = {};
    $$('.pdp-stack', root).forEach(function (el) {
      out[el.getAttribute('data-id')] = {
        el: el,
        name: el.getAttribute('data-name') || '',
        price: parseFloat(el.getAttribute('data-price')) || 0,
        was: parseFloat(el.getAttribute('data-was')) || 0,
        qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
        variant: el.getAttribute('data-variant') || ''
      };
    });
    return out;
  }

  function initBuyBox(root) {
    var buyRef = $('[data-buy-ref]', root);
    if (!buyRef || buyRef.__initDone) return;
    buyRef.__initDone = true;
    var stacks = readStacks(root);
    var state = { stack: (document.querySelector('.pdp[data-pdp-root]') || root).getAttribute('data-default-stack') || Object.keys(stacks)[0] };

    function render() {
      var s = stacks[state.stack]; if (!s) return;
      var unit = s.price;
      var hasWas = s.was && s.was > unit;
      var save = (s.was || s.price) - unit;
      var inst = Math.round(unit / 4 * 100) / 100;
      // stack selection UI
      $$('.pdp-stack', root).forEach(function (el) { el.classList.toggle('on', el === s.el); });
      // price box
      setText(root, '[data-pb-label]', s.name + ' · One-time');
      setText(root, '[data-pb-now]', 'AED ' + AED(unit));
      var wasEl = $('[data-pb-was]', root);
      if (wasEl) {
        if (hasWas) { wasEl.textContent = 'AED ' + AED(s.was); wasEl.style.display = ''; }
        else { wasEl.textContent = ''; wasEl.style.display = 'none'; }
      }
      var saveEl = $('[data-pb-save]', root);
      if (saveEl) {
        if (hasWas) { saveEl.textContent = 'Save AED ' + AED(save); saveEl.style.display = ''; }
        else { saveEl.textContent = ''; saveEl.style.display = 'none'; }
      }
      setText(root, '[data-pb-cta]', 'Add to bag · AED ' + AED(unit));
      setText(root, '[data-pb-inst]', 'Or 4 × AED ' + AED(inst) + ' with');
      /* keep hidden variant input in sync so form POST also works */
      if (s.variant) {
        var vi = $('[data-variant-input]', root) || document.querySelector('[data-variant-input]');
        if (vi) vi.value = s.variant;
      }
    }

    $$('.pdp-stack', root).forEach(function (el) {
      el.addEventListener('click', function () { state.stack = el.getAttribute('data-id'); render(); });
    });

    // add to cart (buy box + sticky bar share this)
    function add() {
      var s = stacks[state.stack]; if (!s) return;
      /* variant fallback: data-variant → hidden input → first available */
      var variantId = s.variant
        || (document.querySelector('[data-variant-input]') || {}).value
        || '';
      if (!variantId) { flash(root, 'No variant found — please select a stack.'); return; }
      var item = { id: variantId, quantity: s.qty || 1 };
      var btns = $$('[data-add-to-bag]', root);
      btns.forEach(function (b) { b.disabled = true; b.classList.add('loading'); });
      addToCart([item], function (ok) {
        btns.forEach(function (b) { b.disabled = false; b.classList.remove('loading'); });
        if (ok) {
          flash(root, 'Added to bag ✓');
          pulse(root);
        } else {
          flash(root, 'Could not add to cart — please try again.');
        }
      });
    }
    $$('[data-add-to-bag]', root).forEach(function (b) { b.addEventListener('click', add); });
    root.__pdpAdd = add;
    root.__pdpState = state;
    root.__pdpStacks = stacks;
    render();
  }

  function setText(root, sel, txt) { var el = $(sel, root); if (el) el.textContent = txt; }

  /* ---------------- Shopify cart helpers ---------------- */
  function openDrawer() {
    var host = document.querySelector('[data-bac-drawer-host]');
    if (!host) return;
    host.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('bac-open');
  }

  function updateCounts(cnt) {
    document.querySelectorAll('.ba-bag-count').forEach(function (el) { el.textContent = cnt; });
    document.querySelectorAll('[data-bac-headcount]').forEach(function (el) { el.textContent = '(' + cnt + ')'; });
    document.querySelectorAll('[data-bac-headcount-bubble]').forEach(function (el) { el.textContent = cnt; el.setAttribute('data-count', cnt); });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble span:first-child').forEach(function (el) { el.textContent = cnt; });
  }

  function applyDrawerSections(sections) {
    /* use bioactive-cart.js applier if loaded, else manual swap */
    if (typeof window.__bacApplySections === 'function') {
      window.__bacApplySections(sections);
      return;
    }
    var html = sections && sections['bioactive-cart-drawer'];
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var newContent = tmp.querySelector('[data-bac-drawer-content]');
    var curContent = document.querySelector('[data-bac-drawer-content]');
    if (newContent && curContent) curContent.innerHTML = newContent.innerHTML;
  }

  function addToCart(items, cb) {
    var valid = items.filter(function (it) { return it.id; });
    if (!valid.length) { if (cb) cb(false); return; }
    if (typeof window.baAddToCart === 'function') {
      window.baAddToCart(valid, {
        noOpen: true,
        onDone: function (cart) {
          if (cart) updateCounts(cart.item_count);
          if (cb) cb(true);
          if (typeof window.__bacOpenDrawer === 'function') window.__bacOpenDrawer();
        },
        onError: function () { if (cb) cb(false); }
      });
      return;
    }
    /* fallback */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: valid })
    })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (data) {
      if (data.sections) applyDrawerSections(data.sections);
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      if (cart) { updateCounts(cart.item_count); document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); }
      if (cb) cb(true);
      openDrawer();
    })
    .catch(function () { if (cb) cb(false); });
  }


  /* ---------------- sticky add-to-cart bar ---------------- */
  function initStickyBar(root) {
    var bar = $('.bb-stickybar', root);
    var buy = $('[data-buy-ref]', root) || $('.pdp-pricebox', root);
    if (!bar || !buy || bar.__initDone) return;
    bar.__initDone = true;
    function onScroll() {
      var bottom = buy.getBoundingClientRect().bottom;
      var nearEnd = document.body.scrollHeight - window.innerHeight - 520;
      bar.classList.toggle('show', bottom < 80 && window.scrollY < nearEnd);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function flash(root, msg) {
    var t = $('.bb-toast', root);
    if (!t) { t = document.createElement('div'); t.className = 'bb-toast'; root.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t.__timer);
    t.__timer = setTimeout(function () { t.classList.remove('show'); }, 2300);
  }
  function pulse(root) {
    $$('.bb-sb-add, [data-add-to-bag]', root).forEach(function (b) {
      b.classList.add('done');
      clearTimeout(b.__timer);
      b.__timer = setTimeout(function () { b.classList.remove('done'); }, 1600);
    });
  }

  /* ---------------- read-more (mobile copy collapse) ---------------- */
  function initReadMore(root) {
    $$('.bz-collapse, .pdp-tagwrap', root).forEach(function (wrap) {
      if (wrap.__initDone) return;
      wrap.__initDone = true;
      var body = wrap.querySelector('.bz-collapse-body') || wrap.querySelector('.pdp-tagline');
      var btn = wrap.querySelector('.bz-collapse-btn') || wrap.querySelector('.pdp-tagmore');
      if (!body || !btn) return;
      var collapsedPx = parseInt(wrap.getAttribute('data-collapsed'), 10) || 58;
      var isTag = body.classList.contains('pdp-tagline');
      var open = false;
      function apply() {
        var mobile = window.matchMedia('(max-width: 700px)').matches;
        if (!mobile) { btn.style.display = 'none'; clamp(false); return; }
        var full = isTag ? (body.scrollHeight > body.clientHeight + 2) : (body.scrollHeight > collapsedPx + 10);
        if (full || open) { btn.style.display = ''; clamp(!open); } else { btn.style.display = 'none'; clamp(false); }
      }
      function clamp(on) {
        if (isTag) { body.classList.toggle('clamp', on); }
        else { body.classList.toggle('clamp', on); body.style.maxHeight = on ? collapsedPx + 'px' : ''; }
      }
      btn.addEventListener('click', function () { open = !open; btn.textContent = open ? 'Read less' : 'Read more'; apply(); });
      apply();
      window.addEventListener('resize', apply);
    });
  }

  /* ---------------- science-viz tabs ---------------- */
  function initSciTabs(root) {
    $$('.bz-sci-card', root).forEach(function (card) {
      if (card.__initDone) return;
      card.__initDone = true;
      var tabs = $$('.bz-sci-tab', card);
      var panels = $$('[data-sci-panel]', card);
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('on'); });
          tab.classList.add('on');
          panels.forEach(function (p, j) { p.hidden = j !== i; });
          var active = panels[i];
          if (active) { active.classList.remove('bz-sci-anim'); void active.offsetWidth; active.classList.add('bz-sci-anim'); }
        });
      });
    });
  }

  /* ---------------- accordions (FAQ + learn) ---------------- */
  function initAccordions(root) {
    $$('.pdp-faq-item', root).forEach(function (item) {
      if (item.__initDone) return;
      item.__initDone = true;
      var q = item.querySelector('.pdp-faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        $$('.pdp-faq-item', root).forEach(function (it) { it.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });
  }

  /* ---------------- ring gauges + bar reveal ---------------- */
  function initRings(root) {
    $$('.bz-ring', root).forEach(function (el) {
      if (el.__initDone) return;
      el.__initDone = true;
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.classList.contains('bz-ring')) {
          var circle = el.querySelector('[data-ring-fill]');
          if (circle) {
            var val = parseFloat(el.getAttribute('data-value')) || 0;
            var r = 52, c = 2 * Math.PI * r;
            circle.style.strokeDasharray = c;
            circle.style.strokeDashoffset = c * (1 - val / 100);
          }
        }
        el.classList.add('in');
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    $$('.bz-ring', root).forEach(function (el) { io.observe(el); });
  }

  /* ---------------- build-a-bundle ---------------- */
  var _bzPanel = document.querySelector('.bz-bundle-panel');
  var _t2 = _bzPanel ? (parseInt(_bzPanel.getAttribute('data-tier2'), 10) || 20) : 20;
  var _t4 = _bzPanel ? (parseInt(_bzPanel.getAttribute('data-tier4'), 10) || 30) : 30;
  var BZ_TIERS = [0, 0, _t2, _t2, _t4];
  function initBundle(root) {
    var section = $('.bz-bundle', root);
    if (!section || section.__initDone) return;
    section.__initDone = true;
    var formulas = {};
    $$('.bz-chip', section).forEach(function (c) {
      formulas[c.getAttribute('data-id')] = {
        id: c.getAttribute('data-id'),
        nm: c.getAttribute('data-name'),
        price: parseFloat(c.getAttribute('data-price')) || 0,
        grad: c.getAttribute('data-grad') || '',
        img: c.getAttribute('data-img') || '',
        variant: parseInt(c.getAttribute('data-variant'), 10) || 0,
        chip: c
      };
    });
    var sel = [];
    function render() {
      var items = sel.map(function (id) { return formulas[id]; });
      var subtotal = items.reduce(function (a, f) { return a + f.price; }, 0);
      var pct = BZ_TIERS[Math.min(sel.length, 4)];
      var savings = Math.round(subtotal * pct) / 100;
      var total = Math.round((subtotal - savings) * 100) / 100;
      // chips
      $$('.bz-chip', section).forEach(function (c) {
        var on = sel.indexOf(c.getAttribute('data-id')) > -1;
        c.classList.toggle('on', on);
        c.disabled = sel.length >= 4 && !on;
        var act = c.querySelector('.bz-chip-act');
        if (act) act.innerHTML = on ? CHECK_SVG : PLUS_SVG;
      });
      // slots
      var slots = $$('.bz-bundle-slot', section);
      slots.forEach(function (slot, i) {
        var f = items[i];
        if (f) {
          if (f.img) {
            // photo fills the whole slot frame (object-fit:cover), name overlaid at the bottom
            slot.className = 'bz-bundle-slot bz-slot-filled bz-slot-photo';
            slot.innerHTML = '<img class="bz-slot-img" src="' + f.img + '" alt="' + f.nm + '">' +
              '<span class="bz-slot-scrim"></span>' +
              '<span class="bz-slot-nm">' + f.nm + '</span>' +
              '<span class="bz-slot-x">' + CLOSE_SVG + '</span>';
          } else {
            slot.className = 'bz-bundle-slot bz-slot-filled';
            slot.innerHTML = '<span class="bz-slot-orb" style="background:' + f.grad + '"></span>' +
              '<span class="bz-slot-nm">' + f.nm + '</span>' +
              '<span class="bz-slot-x">' + CLOSE_SVG + '</span>';
          }
          slot.onclick = function () { sel = sel.filter(function (x) { return x !== f.id; }); render(); };
        } else {
          slot.className = 'bz-bundle-slot bz-slot-empty' + (sel.length === i ? ' next' : '');
          slot.innerHTML = '<span class="bz-slot-plus">' + PLUS_SVG + '</span>';
          slot.onclick = null;
        }
      });
      // discount track — 3 honest nodes: Start (0 boxes) · 2 boxes (t2%) · 4 boxes (t4%)
      var BZ_NODES = [0, 2, 4];
      $$('.bz-bundle-dot', section).forEach(function (d, i) { d.classList.toggle('reached', sel.length >= BZ_NODES[i]); });
      var fill = $('.bz-bundle-fill', section);
      // fill stops JUST SHORT of the next node so it reads as "almost there"
      var BZ_FILL = [0, 42, 50, 84, 100];
      if (fill) fill.style.width = BZ_FILL[Math.min(sel.length, 4)] + '%';
      var hint = $('.bz-bundle-hint', section);
      if (hint) {
        if (sel.length === 0) hint.textContent = 'Add 2 boxes to unlock ' + _t2 + '% off';
        else if (sel.length === 1) hint.textContent = 'Add 1 more box to unlock ' + _t2 + '% off';
        else if (sel.length === 2) hint.textContent = _t2 + '% off unlocked · add 2 more for ' + _t4 + '%';
        else if (sel.length === 3) hint.textContent = 'Add 1 more box to unlock ' + _t4 + '% off';
        else hint.textContent = _t4 + '% off unlocked — max savings!';
      }
      // summary
      var empty = $('.bz-bundle-empty', section), list = $('.bz-bundle-list', section);
      if (sel.length === 0) { if (empty) empty.style.display = ''; if (list) list.style.display = 'none'; }
      else {
        if (empty) empty.style.display = 'none';
        if (list) {
          list.style.display = '';
          list.innerHTML = items.map(function (f) {
            return '<div class="bz-bundle-row"><span class="bz-bundle-rowdot" style="background:' + f.grad + '"></span><span class="nm">' + f.nm + '</span><span class="pr">AED ' + AED(f.price) + '</span></div>';
          }).join('') +
          '<div class="bz-bundle-totals"><div class="r"><span>Subtotal</span><span>AED ' + AED(subtotal) + '</span></div>' +
          '<div class="r save"><span>Bundle saving · ' + pct + '%</span><span>– AED ' + AED(savings) + '</span></div>' +
          '<div class="r total"><span>Total</span><span>AED ' + AED(total) + '</span></div></div>';
        }
      }
      var cta = $('.bz-bundle-cta', section);
      if (cta) cta.disabled = sel.length === 0;
    }
    $$('.bz-chip', section).forEach(function (c) {
      c.addEventListener('click', function () {
        var id = c.getAttribute('data-id');
        if (sel.indexOf(id) > -1) sel = sel.filter(function (x) { return x !== id; });
        else if (sel.length < 4) sel.push(id);
        render();
      });
    });
    var cta = $('.bz-bundle-cta', section);
    if (cta) cta.addEventListener('click', function () {
      if (!sel.length) return;
      var validItems = sel.map(function (id) { return { id: formulas[id].variant || '', quantity: 1 }; }).filter(function (it) { return it.id; });
      if (!validItems.length) { flash(root, 'No variants configured — please set up products in admin.'); return; }
      cta.disabled = true;
      addToCart(validItems, function (ok) {
        cta.disabled = false;
        if (ok) {
          flash(root, 'Bundle added · ' + validItems.length + ' formula' + (validItems.length > 1 ? 's' : '') + ' ✓');
          cta.classList.add('done'); cta.innerHTML = CHECK_SVG + ' Added to bag';
          setTimeout(function () {
            cta.classList.remove('done'); cta.innerHTML = 'Add bundle to cart ' + ARROW_SVG;
            sel = []; render();
          }, 1900);
        } else {
          flash(root, 'Could not add bundle — please try again.');
        }
      });
    });
    render();
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal(root) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    $$('.pdp-reveal', root).forEach(function (el) {
      if (el.__initDone) return;
      el.__initDone = true;
      io.observe(el);
    });
    setTimeout(function () { $$('.pdp-reveal', root).forEach(function (el) { el.classList.add('in'); }); }, 1200);
  }

  /* ---------------- inline icons (for JS-built bits) ---------------- */
  var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PLUS_SVG  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var CLOSE_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ARROW_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h9M8.5 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------------- boot ---------------- */
  function boot() { initRoot(document.body); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Shopify theme-editor: re-init when section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      e.target.__pdpInit = false;
      $$('*', e.target).forEach(function (el) {
        el.__initDone = false;
      });
      initRoot(e.target);
    }
  });
})();
